import { render, staticRenderFns } from "./ConfirmationBox.vue?vue&type=template&id=366ddf4f&scoped=true&"
import script from "./ConfirmationBox.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationBox.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmationBox.vue?vue&type=style&index=0&id=366ddf4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366ddf4f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VExpandTransition,VRow})
